import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    listSecondaryNumbers,
    addSecondaryNumber,
    verifySecondaryOtp,
} from "../../services/api/secondaryNumber.api";
import {
    SecondaryNumber,
    AddSecondaryNumberRequest,
    SecondaryOtpVerifyRequest,
} from "../../services/api/api.types";

export const listSecondaryNumbersThunk = createAsyncThunk<
    SecondaryNumber[],
    void,
    { rejectValue: string }
>("secondary/list", async (_, { rejectWithValue }) => {
    try {
        const res = await listSecondaryNumbers();
        return res.data;
    } catch {
        return rejectWithValue("Failed to fetch secondary numbers");
    }
});

export const addSecondaryNumberThunk = createAsyncThunk<
    void,
    AddSecondaryNumberRequest,
    { rejectValue: string }
>("secondary/add", async (payload, { rejectWithValue }) => {
    try {
        await addSecondaryNumber(payload);
    } catch {
        return rejectWithValue("Failed to add secondary number");
    }
});

export const verifySecondaryOtpThunk = createAsyncThunk<
    void,
    SecondaryOtpVerifyRequest,
    { rejectValue: string }
>("secondary/verifyOtp", async (payload, { rejectWithValue }) => {
    try {
        await verifySecondaryOtp(payload);
    } catch {
        return rejectWithValue("Secondary OTP verification failed");
    }
});
